import { useEffect, useContext, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { hideSideBarDesktop } from "../../utils/funciones";
import { useAjustesDias } from "./useAjustesDias";
import { DataContextContractual } from "../../contextData/contextData";
import { modalEditarDiasAnticipacion } from "../../components/ui/sweetAlerts";

export const AjustesDeDias = () => {
  const { enviar } = useAjustesDias();
  const { configuracionesDias, diasAnticipoGeneral, diasAnticipoRenovacion } =
    useContext(DataContextContractual);

  useEffect(() => {
    hideSideBarDesktop();
  }, []);

  const tableData = useMemo(() => {
    const list =
      Array.isArray(configuracionesDias) && configuracionesDias.length > 0
        ? configuracionesDias
        : [
            { id: 1, dias_anticipacion: diasAnticipoGeneral || "-" },
            { id: 2, dias_anticipacion: diasAnticipoRenovacion || "-" },
          ];

    return list.map((item) => ({
      ...item,
      nombre:
        Number(item.id) === 1
          ? "Días de anticipación para cambios contractuales"
          : "Días de anticipación para renovaciones",
      aplica_a:
        Number(item.id) === 1
          ? ["Cambio de Cargo", "Cambio de Instalación", "Cambio de Unidad (Temporis)"]
          : ["Renovaciones (Plazo Fijo a Indefinido)"],
    }));
  }, [configuracionesDias, diasAnticipoGeneral, diasAnticipoRenovacion]);

  const abrirModalEditar = (row) => {
    modalEditarDiasAnticipacion(row, enviar);
  };

  return (
    <div className="container-fluid py-4 px-4" style={{ maxWidth: "1100px" }}>
      {/* Grid de Tarjetas de Configuración */}
      <div className="row g-4">
        {tableData.map((item) => {
          const flujosList = Array.isArray(item.aplica_a)
            ? item.aplica_a
            : String(item.aplica_a).split(",").map((s) => s.trim());

          const isCargando = item.dias_anticipacion === "-";

          return (
            <div key={item.id} className="col-12 col-md-6">
              <div
                className="card h-100 border-0"
                style={{
                  borderRadius: "14px",
                  background: "#ffffff",
                  border: "1px solid #e2e8f0",
                }}
              >
                <div className="card-body p-4 d-flex flex-column justify-content-between">
                  <div>
                    {/* Nombre del Parámetro */}
                    <h6 className="fw-bold mb-3" style={{ color: "#0f172a", fontSize: "1.02rem" }}>
                      {item.nombre}
                    </h6>

                    {/* Badges de Flujos Aplicables */}
                    <div className="mb-4 d-flex flex-wrap gap-2" style={{ gap: "8px" }}>
                      {flujosList.map((flujo) => (
                        <span
                          key={flujo}
                          className="badge px-3 py-1.5 rounded-pill fw-semibold"
                          style={{
                            backgroundColor: "#f1f5f9",
                            color: "#475569",
                            border: "1px solid #e2e8f0",
                            fontSize: "0.78rem",
                          }}
                        >
                          {flujo}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Valor de días y botón de edición */}
                  <div
                    className="p-3 rounded-3 d-flex align-items-center justify-content-between"
                    style={{ backgroundColor: "#f8fafc", border: "1px solid #e2e8f0" }}
                  >
                    <div className="d-flex align-items-baseline gap-1">
                      <span style={{ fontSize: "1.8rem", fontWeight: "800", color: "#0f172a", lineHeight: 1 }}>
                        {item.dias_anticipacion}
                      </span>
                      <span className="fw-bold" style={{ fontSize: "0.88rem", color: "#64748b" }}>
                        días de anticipación
                      </span>
                    </div>

                    <button
                      type="button"
                      className="btn px-4 py-2 rounded-pill fw-bold text-white d-inline-flex align-items-center transition-all ms-2"
                      style={{
                        backgroundColor: "#2a77b9",
                        border: "none",
                        opacity: isCargando ? 0.6 : 1,
                        cursor: isCargando ? "not-allowed" : "pointer",
                      }}
                      disabled={isCargando}
                      onClick={() => abrirModalEditar(item)}
                    >
                      <FontAwesomeIcon icon={faEdit} className="me-2" />
                      Editar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

